// TextArea
import React from "react";
import Tooltip, { TooltipProps } from "../Tooltip";
import cn from "classnames";
import styles from "./TextArea.module.sass";

export interface TextAreaProps
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  classWrapper?: string;
  classLabel?: string;
  label?: string;
  tooltip?: string;
  place?: TooltipProps["place"];
  theme?: "light" | "dark";
}

const TextArea: React.FC<TextAreaProps> = ({
  className,
  classWrapper,
  classLabel,
  label,
  tooltip,
  place,
  theme = "dark",
  rows = 4,
  ...props
}) => {
  return (
    <div className={cn(styles.wrapper, classWrapper)}>
      {label && (
        <div
          className={cn(styles.label, classLabel, {
            [styles.light]: theme === "light",
            [styles.dark]: theme === "dark",
          })}
        >
          {label}{" "}
          {tooltip && (
            <Tooltip
              className={styles.tooltip}
              tooltipContent={tooltip}
              icon="info"
              place={place ? place : "right"}
            />
          )}
        </div>
      )}
      <textarea
        className={cn(styles.textArea, className, {
          [styles.light]: theme === "light",
          [styles.dark]: theme === "dark",
        })}
        rows={rows}
        {...props}
      />
    </div>
  );
};

export default TextArea;
